module.exports = __webpack_public_path__ + "img/image29.d28dd0f4.jpeg";